export default __webpack_public_path__ + "static/media/JM.298ce38f.svg";